"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentryUtils = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const Loggy_1 = require("../logger/Loggy");
class SentryUtils {
    static severityToLoggyLogLevel(severity) {
        switch (severity) {
            case 'error':
            case 'fatal':
                return Loggy_1.LoggyLevel.error;
            case 'debug':
                return Loggy_1.LoggyLevel.debug;
            case 'info':
                return Loggy_1.LoggyLevel.info;
            case 'log':
                return Loggy_1.LoggyLevel.log;
            case 'warning':
                return Loggy_1.LoggyLevel.warn;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(severity);
        }
    }
}
exports.SentryUtils = SentryUtils;
//# sourceMappingURL=sentry-utils.js.map